import axiosInstance from "../api/axiosInstance";

const BASE = "/client/account-deletion";

const handle = async (fn) => {
  try {
    const res = await fn();
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || err.message || "Something went wrong.",
    };
  }
};

export const requestOtp = () => handle(() => axiosInstance.post(`${BASE}/request-otp`));
export const confirmDeletion = (otp) => handle(() => axiosInstance.post(`${BASE}/confirm`, { otp }));
export const getDeletionStatus = () => handle(() => axiosInstance.get(`${BASE}/status`));
export const cancelDeletion = () => handle(() => axiosInstance.post(`${BASE}/cancel`));
